export async function createWorker(url) {
  const text = await fetch(url).then(r => r.text());
  const blob = new Blob([text]);
  const urlObj = URL.createObjectURL(blob);
  const worker = new Worker(urlObj);
  URL.revokeObjectURL(urlObj);
  return worker;
}
//# sourceMappingURL=worker.js.map